import request from "../../utils/fetch";

export const login = (postData) =>
  request.post(`subscription/admin/login`, postData);
